import { render, staticRenderFns } from "./SpalSection.vue?vue&type=template&id=523f3745&scoped=true"
import script from "./SpalSection.vue?vue&type=script&lang=js"
export * from "./SpalSection.vue?vue&type=script&lang=js"
import style0 from "./SpalSection.vue?vue&type=style&index=0&id=523f3745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f3745",
  null
  
)

export default component.exports